import { render, staticRenderFns } from "./MultipleDid.vue?vue&type=template&id=2362950e&"
import script from "./MultipleDid.vue?vue&type=script&lang=js&"
export * from "./MultipleDid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports